module.exports = __webpack_public_path__ + "static/media/University-of-Michigan-Logo.06e99df1.png";